/*
 * Copyright (c) Nexign, JSC, 2021-2025.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Nikolay Sviridov
 * @version 1.36.0
 * @since 1.14.1
 */
import produce from 'immer';
import { Reducer } from 'redux';

import { WIZARD_STORAGE_CLEAR_STEPS } from '../../modules/wizard/wizardConstants';
import { TWizardBillsDocActions } from './types/wizardBillsDocActionTypes';
import { EWizardBillsDocWithDetailStatus } from './types/wizardBillsDocTypes';
import {
    WIZARD_BILLS_DOC_SET_PARAMS,
    WIZARD_BILLS_DOC_VALIDATE_FINISH,
    WIZARD_BILLS_DOC_VALIDATE_START,
} from './wizardBillsDocConsant';

export interface IWizardBillsDocReducer {
    formatsAvailable: string[];
    formatChoose: string;
    // Счет
    isOrderChecked: boolean;
    isOrderWithDetailChecked: boolean;
    orderWithDetailStatus: EWizardBillsDocWithDetailStatus;
    // Счет-фактура
    isInvoiceAvailable: boolean;
    isInvoiceChecked: boolean;
    // Исключить авансовые счета-фактуры
    isAdvanceInvoiceAvailable: boolean;
    isAdvanceInvoiceChecked: boolean;
    // Счет на оплату
    isInvoiceOrderAvailable: boolean;
    isInvoiceOrderChecked: boolean;
    // Акт оказанных услуг
    isActOrderAvailable: boolean;
    isActOrderChecked: boolean;
    // Для мастеров быстрого заказа по рычагу mainOperations
    isFastBillsDocPreselect?: boolean;
    isFastInvoicePreselect?: boolean;
    isInitialCheckboxes: boolean;

    isStepValid: boolean;
}

export const initialWizardBillsDocState: IWizardBillsDocReducer = {
    formatChoose: '',
    formatsAvailable: [],
    isActOrderAvailable: false,
    isActOrderChecked: false,
    isAdvanceInvoiceAvailable: false,
    isAdvanceInvoiceChecked: false,
    isInvoiceAvailable: false,
    isInvoiceChecked: false,
    isInvoiceOrderAvailable: false,
    isInvoiceOrderChecked: false,
    isOrderChecked: false,
    isOrderWithDetailChecked: false,
    isFastBillsDocPreselect: undefined,
    isFastInvoicePreselect: undefined,
    isInitialCheckboxes: true,
    isStepValid: true,
    orderWithDetailStatus: EWizardBillsDocWithDetailStatus.enable,
}

const wizardBillsDocReducer: Reducer<IWizardBillsDocReducer, TWizardBillsDocActions> =
    (state = initialWizardBillsDocState, action: TWizardBillsDocActions) =>
        produce(state, draft => {
            switch (action.type) {
                case WIZARD_BILLS_DOC_VALIDATE_START:
                    break;
                case WIZARD_BILLS_DOC_VALIDATE_FINISH:
                    draft.isStepValid = action.payload.isStepValid;
                    break;

                case WIZARD_BILLS_DOC_SET_PARAMS:
                    Object.assign(draft, { ...draft, ...action.payload });
                    break;

                case WIZARD_STORAGE_CLEAR_STEPS:
                    Object.assign(draft, initialWizardBillsDocState);
                    break;
            }
        })

export default wizardBillsDocReducer;
